import _ from 'lodash';
import React, { Component } from 'react';
import moneyFormat, { moneyFormatFromCents } from '../../utilities/moneyFormat';
import { JqueryClassFaker } from '../components/JqueryClassFaker';

/**
 *
 * @param amountInCents | CENTS
 * @param showMinusSignIfNegative
 * @param flipPositivity
 * @param showPositive
 * @param showNegative
 * @param showPlus
 * @param showTitleInstead
 * @param title
 * @param round
 * @param children
 * @returns {*}
 * @constructor
 */
function MoneyComponent({
	                        amount: amountInCents = null,
	                        showMinusSignIfNegative = true,
							flipPositivity = false,
	                        showPositive,
	                        showNegative,
	                        showPlus,
	                        showTitleInstead,
	                        title,
	                        round,
							children,
                        }) {
	const showCoolDisplay = false;
	let amountValue = amountInCents;
	if(_.isString(amountInCents)) {
		amountValue = amountInCents.replace('$', '').replace(',', '');
	}
	if(round) {
		amountValue = Math.round(amountValue);
	}
	if(Number.isNaN(amountValue)) {
		console.log('what is amountInCents', amountInCents);
	}
	if(flipPositivity) {
		amountValue = amountValue * -1;
	}
	const classes = new JqueryClassFaker();
	const isPositive = amountValue >= 0;
	const isNegative = amountValue < 0;

	if(showNegative === undefined && showPositive === undefined) {
		if(isPositive) {
			classes.add('positive');
		}
		else {
			classes.add('negative');
		}
	}
	else {
		if(showPositive) {
			classes.add('positive');
		}
		else if(showNegative) {
			classes.add('negative');
		}
		else {
			classes.add('neutral');
		}
	}
	const amountToUseForDisplay = !showMinusSignIfNegative && amountValue < 0 ? Math.abs(amountValue) : amountValue;
	const moneyFormatted = moneyFormatFromCents(amountToUseForDisplay, { minimumFractionDigits: round ? 0 : 2 });
	const split =
		[
			(amountValue > 0) ? Math.floor(amountValue) : Math.ceil(amountValue),
			Math.abs(Math.round(((amountValue % 1) * 100)))
		];
	split[1] = Math.abs(split[1]) > 9 ? String(split[1]) : (split[1] + "0").slice(-2);
	let output = null;
	if(showCoolDisplay) {
		output = <React.Fragment>
			{showPlus && isPositive && <span className='the_plus'>+</span>}
			{showPlus && isNegative && <span className='the_minus'>-</span>}
			$
			<span className='dollars'>{split[0]}</span>
			<span className='cents'>{split[1]}</span>
		</React.Fragment>;
	}
	else {
		output = <React.Fragment>
			{`${showPlus && isPositive ? '+' : ''}${moneyFormatted}`}
		</React.Fragment>;
	}
	if(amountInCents !== null) {
		return (
			<span
				className={`money_display ${classes.toString()}`}>
				{children}
				<span
					style={{
						opacity: showTitleInstead ? 1 : 0,
						position: 'absolute',
						top: 0,
						left: 0,
						width: '100%',
					}}
					className='alternative_title'>
					{title}
				</span>
				<span
					style={{ opacity: showTitleInstead ? 0 : 1, position: 'relative' }}
					className='amount_value'>
					{output}
					</span>
			</span>
		);
	}
	return (
		<span className='money_display'>
			Unknown
		</span>
	);
}

export default React.memo(MoneyComponent);
